export interface VerificationDocumentResponseViewModel {
	base64String: string;
	contentType: string;
}

export enum VerificationDocumentType {
	Id = 1,
	Selfie,
}
